import OptionalOriginManager from "./OptionalOriginManager";

export default OptionalOriginManager;
export { OptionalOriginManager };
